import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowBranch = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5385 26.1538H21.548C21.1772 26.1538 20.8125 26.0542 20.4882 25.8645C20.1639 25.6747 19.8906 25.4011 19.6941 25.0691L16.6924 19.9999L19.6941 14.9307C19.8906 14.5988 20.1639 14.3251 20.4882 14.1354C20.8125 13.9456 21.1772 13.8461 21.548 13.8461H30.5385",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6923 20H9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4614 10L31.3076 13.8462L27.4614 17.6923",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4614 22.3077L31.3076 26.1539L27.4614 30",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgArrowBranch);
export default ForwardRef;
